<ng-container *ngIf="vm$ | async as vm">
	<app-onboarding-container
		imageUrl="/assets/images/auth/undraw-welcoming.webp"
		headingText="You've got an Invite"
		alternativeText="Man waving next to a tree"
	>
		<ng-container paragraph-content>
			<p>
				To join your colleagues select from the business{{
					vm.invites.length > 1 ? 'es' : ''
				}}
				below.
			</p>
			<!-- This will change from a radio group to checkboxes for accepting multiple businesses  -->
			<app-radio-group
				orientation="vertical"
				[items]="vm.invites"
				[(ngModel)]="vm.selectedInvite"
			></app-radio-group>
		</ng-container>

		<div cta-content class="flex flex-col gap-2 justify-center items-center">
			<ui-button
				preset="HIGH_EMPHASIS"
				label="Join Business"
				size="md"
				(click)="acceptInvite()"
			></ui-button>
			<ui-button
				preset="LOW_EMPHASIS"
				label="Create New"
				(click)="createNewBusiness()"
			></ui-button>
		</div>
	</app-onboarding-container>
</ng-container>
